import {combineReducers} from 'redux';
import AuthReducer from './auth'
import CountReducer from './sidebar'
import {LoginValidationUIReducer } from './validationStateUI';
import {MapReducer} from './map';
import OfelUserReducer from './ofelUser'

const RootReducer= combineReducers({
       auth:AuthReducer,
       loginValidationUI:LoginValidationUIReducer,
       map:MapReducer,
       user:OfelUserReducer,
       counts:CountReducer
   })

export default RootReducer;